import * as Sentry from '@sentry/react';
import { type FC, type ReactNode, useEffect } from 'react';
import { useMe } from '@/account/profile/api';

export const SentryProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const me = useMe();

  useEffect(() => {
    if (me.data?.external_id) {
      Sentry.setUser({
        id: me.data?.external_id,
        email: me.data?.email ?? undefined,
        username: me.data?.username,
        ip_address: '{{auto}}',
      });
    } else {
      Sentry.setUser(null);
    }
  }, [me.data?.username, me.data?.external_id, me.data?.email]);

  return <>{children}</>;
};
